import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ActionItems.scss";
import Portfolio from "../../core/enums/Portfolio";
import { IProps } from "../../App";

interface ActionItemsProps extends IProps { //TODO: move to different file?
  location: Portfolio
}

const ActionItems = (props: ActionItemsProps) => {
  const linkedInButtonClickHandler = (): void => {
    window.open('https://www.linkedin.com/in/brian-lowther/', '_blank', 'noopener,noreferrer');
  }

  return (
    <div className="action-items">
      <button className="personal-button linkedin" onClick={linkedInButtonClickHandler}>
        <FontAwesomeIcon icon={faLinkedin} size="2x" />
      </button>
      {
        Object.values(Portfolio)
          .map((portfolio) =>
            <button
              hidden={portfolio === props.location}
              key={portfolio}
              className="website-portfolio-button"
              onClick={() => props.changeLocation(portfolio)}
            >
              {portfolio} <br/> Portfolio
            </button>
        )
      }
    </div>
  );
}

export default ActionItems;